import { graphql } from 'gatsby'
import React from 'react'
import { Link, StaticQuery } from 'gatsby'
import { ThemedComponent } from '../theme'
import './style.scss'

export default class Footer extends ThemedComponent {
    render() {
        const {
            backgroundClass,
            textColor: themeTextColor,
            //    name: themeName
        } = this.context.theme
        const { className, ...props } = this.props
        return (
            <StaticQuery
                query={graphql`
                    query {
                        wordpressAcfOptions {
                            options {
                                contact_information
                                phone_number
                                email
                            }
                        }
                    }
                `}
                render={data => {
                    const {
                        //contact_information,
                        //phone_number,
                        email,
                    } = data.wordpressAcfOptions.options
                    //const address = contact_information.replace(/\n/g, '<br />')
                    return (
                        <footer
                            className={`Footer px-yd ${backgroundClass} ${className}`}
                            {...props}
                            style={Object.assign(
                                {},
                                // Request by max.  kept incase we change our mind
                                // {
                                //     borderTop:
                                //         themeName === 'dark'
                                //             ? `1px solid #333333`
                                //             : `1px solid #DDDDDD`,
                                // },
                                props.style
                            )}
                        >
                            <div className="container-fluid p-0">
                                <div className="row">
                                    <div className="col-12 col-md-4 col-lg-6 home-link">
                                        <Link to="/">
                                            <YDLogoComponent
                                                color={themeTextColor}
                                            />
                                        </Link>
                                    </div>
                                    <div className="col-12 col-md-4 col-lg-3 address">
                                        {/* <div
                                            dangerouslySetInnerHTML={{
                                                __html: address,
                                            }}
                                        /> */}
                                    </div>
                                    <div className="col-12 col-md-4 col-lg-3 phone-email">
                                        <a href={`mailto:${email}`}>{email}</a>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    )
                }}
            />
        )
    }
}

const YDLogoComponent = ({ color = '#000000' }) => (
    <svg data-name="Layer 1" viewBox="0 0 200 42">
        <title>{'YD-logotype'}</title>
        <path
            fill={color}
            d="M11.12 27L4.72 9.5H0l8.89 23.09L8 35a3.33 3.33 0 0 1-3.52 2.43H2.33v4h2.74c3.45 0 5.47-1.47 6.78-4.9l10.49-27h-4.77zM64.22 0v12.26A9.36 9.36 0 0 0 56.94 9C50.61 9 46 13.93 46 20.76s4.6 11.71 11.18 11.71a9.21 9.21 0 0 0 7.15-3.25v2.71h4.15V0zm-6.83 28.53c-4.27 0-7-3.05-7-7.77s2.86-7.81 6.95-7.81 7 3.14 7 7.81-2.86 7.77-6.95 7.77zM36.11 24.43a8.14 8.14 0 0 1-3.65-1 6.57 6.57 0 0 0-2.82-.8 3.35 3.35 0 0 0-2.08.73A2.47 2.47 0 0 1 26 24a2.2 2.2 0 0 1-2.18-2.21c0-2.35 2.8-3.63 5.43-3.63a7.77 7.77 0 0 1 3.63 1 6.3 6.3 0 0 0 2.81.84 3.46 3.46 0 0 0 2.1-.71 2.52 2.52 0 0 1 1.51-.56 2.2 2.2 0 0 1 2.21 2.18c.03 2.3-2.7 3.52-5.4 3.52zM84 9c-6.39 0-11 4.95-11 11.76s4.62 11.76 11.23 11.76c5 0 9.15-2.83 10.46-7.21l.2-.66h-4.48l-.13.32c-.85 2.16-3.24 3.55-6.08 3.55a6.35 6.35 0 0 1-6.79-6.11h17.45v-2A12 12 0 0 0 92 12.3 10.47 10.47 0 0 0 84 9zm0 4a6.08 6.08 0 0 1 6.36 5.54H77.53A6.43 6.43 0 0 1 84 13zM108 18.33c-3-.56-4.85-1-4.85-2.88 0-1.59 1.57-2.66 3.9-2.66s3.88 1 4.15 2.94l.06.44h4.13v-.55C115 11.7 111.72 9 107.29 9 102.43 9 99 11.64 99 15.46c0 5 4.24 5.88 7.64 6.56 3.21.64 5.18 1.15 5.18 3.37 0 2-1.72 3.24-4.48 3.24s-4.48-1.17-4.81-3.48l-.06-.44h-4.15l.05.56c.42 4.52 3.72 7.22 8.83 7.22 5.29 0 8.84-2.92 8.84-7.27-.04-5.39-4.44-6.22-8.04-6.89zM121.41 9.51h4.27v22.45h-4.27zM123.61.89a2.8 2.8 0 0 0-2.86 2.86 2.88 2.88 0 1 0 5.76 0 2.82 2.82 0 0 0-2.9-2.86zM148.24 12.26A9.37 9.37 0 0 0 141 9c-6.34 0-10.94 5-10.94 11.8s4.6 11.72 11.19 11.72a9.21 9.21 0 0 0 7.16-3.25v2.2c0 4.36-2.35 6.66-6.79 6.66-3.09 0-5.23-1.29-5.73-3.44l-.09-.4h-4.11l.11.6c.79 4.31 4.64 7.1 9.82 7.1 6.75 0 10.94-4 10.94-10.53V9.51h-4.27zm-6.83 16.29c-4.27 0-7-3.05-7-7.78s2.86-7.82 7-7.82 7 3.14 7 7.82-2.9 7.78-6.99 7.78zM169.07 9a8.13 8.13 0 0 0-6.29 2.78V9.51h-4.27V32h4.27V18.67a5.45 5.45 0 0 1 5.51-5.67 4.91 4.91 0 0 1 5 5.14V32h4.27V18c.02-5.33-3.48-9-8.49-9zM192 18.33c-3-.56-4.85-1-4.85-2.88 0-1.59 1.57-2.66 3.9-2.66s3.88 1 4.15 2.94l.06.44h4.13v-.55C199 11.7 195.68 9 191.25 9c-4.86 0-8.26 2.67-8.26 6.49 0 5 4.24 5.88 7.64 6.56 3.21.64 5.18 1.15 5.18 3.37 0 2-1.72 3.24-4.48 3.24s-4.48-1.17-4.81-3.48l-.06-.44h-4.17l.05.56c.42 4.52 3.72 7.22 8.83 7.22 5.28 0 8.84-2.92 8.84-7.27-.01-5.42-4.45-6.25-8.01-6.92z"
        />
    </svg>
)
